import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ellipse',
})
export class EllipsePipe implements PipeTransform {

  transform(value: string, length = 50): unknown {
    if (!value) {
      return '';
    }
    if (value.length > length) {
      return value.substring(0, length) + '...';
    }
    return value;
  }

}
